<template>
  <div class="km-page">
    <header class="km-top">
      <button class="km-back" @click="back()" aria-label="Back">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <div class="km-top__title"><span class="km-top__dot"></span><h1>{{ $t('setting.modify_real_name') }}</h1></div>
      <button class="km-top__save" @click="save()">{{ $t('setting.save') }}</button>
    </header>

    <main class="km-main">
      <section class="km-section">
        <div class="km-card">
          <label class="km-field">
            <span class="km-field__lbl">{{ $t('setting.name') }}</span>
            <input
              v-model="name"
              :readonly="userInfo.name !== ''"
              :placeholder="$t('setting.name_place')"
              :class="{ 'is-readonly': userInfo.name }"
            />
          </label>
        </div>
        <p class="km-hint">{{ $t('setting.name_tip') }}</p>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  data() { return { name: "", userInfo: {} }; },
  methods: {
    back() { return window.history.back(); },
    save() {
      if (this.userInfo.name) { this.$toast(this.$t("setting.repect")); return true; }
      if (!this.name) { this.$toast.fail(this.$t("setting.name_place")); return false; }
      this.$http({ method: 'get', data: { name: this.name }, url: 'user_set_name' }).then(res => {
        if (res.code === 200) {
          this.getUserInfo();
          this.name = this.userInfo.name;
          this.$toast(res.msg);
        } else if (res.code === 401) { this.$toast(res.msg); }
      });
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) { this.userInfo = res.data; this.name = res.data.name; }
        else if (res.code === 401) { this.$toast(res.msg); }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) this.$router.push({ path: '/Login' });
    else this.getUserInfo();
  }
};
</script>

<style lang="less" scoped>
@import "./_km-page.less";
.km-hint {
  padding: 10px 4px 0; margin: 0;
  font-size: 12px; color: #ef4444; font-weight: 500;
}
</style>
